<template>
  <v-dialog v-model="openFlag">

    <c-card class="white" title="예약 세부 정보">
      <template #headItems>
        <c-btn color="blue" outlined @click="openFlag = false">닫기</c-btn>
      </template>

      <v-row>
        <v-col cols="12">
          <reservation-detail :reservationData="reservationDetailInfo"/>
        </v-col>
      </v-row>
    </c-card>

  </v-dialog>
</template>
<script>
  import ReservationDetail from '../Common/ReservationDetail';
  export default {
    components: {ReservationDetail},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      reservationDetailInfo: {
        type: Object,
        default: () => {}
      },
    },
    data: () => ({
      openFlag: false,
    }),
    computed: {
    },
    watch: {
      open: function (value) {
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
    },
    methods: {

    },
    mounted() {

    },
  }
</script>
